// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2FXYu","content":"Consent_content__2x960","footer":"Consent_footer__3lw6g"};